import { Route, Switch, useLocation } from 'react-router';
import React from "react";
import { MobileRouterPaths } from "../mobileAppConstants.js";
import MobileProfile from "../components/MobileProfile/MobileProfile.jsx";
import MobilePortfolio from "../components/MobilePortfolio/MobilePortfolio.jsx";
import MobileAssets from "../components/MobileAssets.jsx";
import MobileAppPrivateRoute from "../components/MobileAppPrivateRoute.jsx";
import MobileAppLogin from "./MobileAppLogin/MobileAppLogin.jsx";
import { Redirect } from "react-router-dom";
import MobileAppAuth from "./MobileAppAuth/MobileAppAuth.jsx";
import MobileAppFirstStart from "./MobileAppFirstStart/MobileAppFirstStart";
import MobileAppRegistration from "./MobileAppRegistration/MobileAppRegistration";
import MobileAppForgotPassword from "./MobileAppForgotPassword/MobileAppForgotPassword";
import MobileAppResetPassword from "./MobileAppResetPassword/MobileAppResetPassword";
import MobileAppBrokenLink from "./MobileAppBrokenLink/MobileAppBrokenLink";
import MobileAppPageNotFound from "./MobileAppPageNotFound";
import MobileAppConfirm from "./MobileAppConfirm";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext.js";
import ErrorBoundary from "../../app/ErrorBoundary.jsx";

function MobileRoutePage() {
    const location = useLocation();
    const {getLangPath} = useLangContext();

    return <ErrorBoundary
        from={'app'}
        headerText={getLangPath('error.default_message')}
        linkText={(getLangPath('error.go_back'))}
    >
        <Switch>
            <Route exact path={MobileRouterPaths.login} component={MobileAppLogin}/>
            <Route exact path={MobileRouterPaths.auth} component={MobileAppAuth}/>
            <Route exact path={MobileRouterPaths.firstStart} component={MobileAppFirstStart}/>
            <Route exact path={MobileRouterPaths.forgot} component={MobileAppForgotPassword}/>
            <Route exact path={MobileRouterPaths.registration} component={MobileAppRegistration}/>
            <Route exact path={MobileRouterPaths.reset} component={MobileAppResetPassword}/>
            <Route exact path={MobileRouterPaths.brokenLink} component={MobileAppBrokenLink}/>
            <Route exact path={MobileRouterPaths.confirm} component={MobileAppConfirm}/>
            <MobileAppPrivateRoute exact path={MobileRouterPaths.default}>
                <Redirect to={{
                    pathname: MobileRouterPaths.portfolio,
                    search: location.search,
                    state: {
                        originPathname: location.pathname,
                        originSearch: location.search,
                        ...location.state,
                    }
                }}/>
            </MobileAppPrivateRoute>
            <MobileAppPrivateRoute path={MobileRouterPaths.portfolio} component={MobilePortfolio}/>
            <MobileAppPrivateRoute path={MobileRouterPaths.market} component={MobileAssets}/>
            <MobileAppPrivateRoute path={MobileRouterPaths.profile} component={MobileProfile}/>
            <Route path="**" component={MobileAppPageNotFound}/>
        </Switch>
    </ErrorBoundary>
}

export default MobileRoutePage;
